import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock, Fragment as _Fragment, TransitionGroup as _TransitionGroup, Teleport as _Teleport, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card card--post" }
const _hoisted_2 = { style: {"padding":"15px","display":"flex","align-items":"center","gap":"10px"} }
const _hoisted_3 = { style: {"flex":"1"} }
const _hoisted_4 = { style: {"padding":"0 15px 15px"} }
const _hoisted_5 = { style: {"display":"flex","justify-content":"space-between","align-items":"center"} }
const _hoisted_6 = { style: {"display":"flex","gap":"20px"} }
const _hoisted_7 = { class: "p-relative post-card-inner" }
const _hoisted_8 = {
  class: "body",
  ref: "bodyRef"
}
const _hoisted_9 = {
  key: 0,
  class: "SignalCardInfoDv"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_PostInfoComponent = _resolveComponent("PostInfoComponent")!
  const _component_PostProfile = _resolveComponent("PostProfile")!
  const _component_PostTextComponent = _resolveComponent("PostTextComponent")!
  const _component_PostMetaComponent = _resolveComponent("PostMetaComponent")!
  const _component_FeedCandleChart = _resolveComponent("FeedCandleChart")!
  const _component_WatchlistContainerComponent = _resolveComponent("WatchlistContainerComponent")!
  const _component_PredictionContainerComponent = _resolveComponent("PredictionContainerComponent")!
  const _component_PostSectionSelectionPreviewComponent = _resolveComponent("PostSectionSelectionPreviewComponent")!
  const _component_PostSectionSelectionRelationPreviewComponent = _resolveComponent("PostSectionSelectionRelationPreviewComponent")!
  const _component_PostPreviewComponent = _resolveComponent("PostPreviewComponent")!
  const _component_SignalCardItem = _resolveComponent("SignalCardItem")!
  const _component_PortfolioTradePostingCardComponent = _resolveComponent("PortfolioTradePostingCardComponent")!
  const _component_PostMediaComponent = _resolveComponent("PostMediaComponent")!
  const _component_PostCardComponent = _resolveComponent("PostCardComponent", true)!
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _component_PostFootComponent = _resolveComponent("PostFootComponent")!
  const _component_Lazy = _resolveComponent("Lazy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, {
      name: "height-expand",
      mode: "out-in",
      onAfterEnter: _ctx.onSkeletonLoaded
    }, {
      default: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "post-content-container skeleton-container",
              ref: "skeletonRef",
              style: _normalizeStyle(_ctx.computedHeightStyle)
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_el_skeleton, {
                  loading: _ctx.loading,
                  class: "custom-dark-skeleton",
                  animated: ""
                }, {
                  template: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_el_skeleton_item, {
                        variant: "circle",
                        style: {"width":"50px","height":"50px"}
                      }),
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_el_skeleton_item, {
                          variant: "text",
                          style: {"width":"120px","height":"16px","margin-bottom":"5px"}
                        }),
                        _createVNode(_component_el_skeleton_item, {
                          variant: "text",
                          style: {"width":"80px","height":"14px"}
                        })
                      ]),
                      _createVNode(_component_el_skeleton_item, {
                        variant: "text",
                        style: {"width":"60px","height":"14px"}
                      })
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_el_skeleton_item, {
                        variant: "text",
                        style: {"width":"90%","height":"16px","margin-bottom":"8px"}
                      }),
                      _createVNode(_component_el_skeleton_item, {
                        variant: "text",
                        style: {"width":"75%","height":"16px","margin-bottom":"8px"}
                      }),
                      _createVNode(_component_el_skeleton_item, {
                        variant: "text",
                        style: {"width":"85%","height":"16px","margin-bottom":"15px"}
                      }),
                      _createVNode(_component_el_skeleton_item, {
                        variant: "square",
                        style: {"width":"100%","height":"200px","margin-bottom":"15px"}
                      }),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_el_skeleton_item, {
                            variant: "text",
                            style: {"width":"40px","height":"14px"}
                          }),
                          _createVNode(_component_el_skeleton_item, {
                            variant: "text",
                            style: {"width":"40px","height":"14px"}
                          }),
                          _createVNode(_component_el_skeleton_item, {
                            variant: "text",
                            style: {"width":"40px","height":"14px"}
                          })
                        ]),
                        _createVNode(_component_el_skeleton_item, {
                          variant: "text",
                          style: {"width":"50px","height":"14px"}
                        })
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ], 4))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onAfterEnter"]),
    _createVNode(_Transition, {
      name: "height-expand",
      mode: "out-in",
      onEnter: _ctx.onContentEnter
    }, {
      default: _withCtx(() => [
        (!_ctx.loading)
          ? (_openBlock(), _createBlock(_component_Lazy, {
              key: 0,
              id: "postCard",
              unrender: false,
              setMinHeight: _ctx.isDetailView == undefined && _ctx.isRepostView == undefined,
              renderOnIdle: false,
              class: "post-content-container",
              style: _normalizeStyle(_ctx.computedHeightStyle),
              ref: "contentRef"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", {
                    style: _normalizeStyle({
            borderLeftColor:
              (_ctx.post?.color ? _ctx.post.color : 'rgb(139, 119, 207)') + ' !important',
          }),
                    class: _normalizeClass(["card card--post height-transition", {
            'content-loaded': _ctx.isContentStable,
            'card--repost': _ctx.isRepostView,
          }])
                  }, [
                    _createVNode(_Transition, { name: "fade-down" }, {
                      default: _withCtx(() => [
                        (_ctx.isDetailView)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.viewPostDetail && _ctx.viewPostDetail(...args)), ["stop"])),
                              class: "post-detail-header-container"
                            }, [
                              _createElementVNode("p", null, _toDisplayString(_ctx.$t("profileDetails.labels.Comments")), 1),
                              _createElementVNode("i", {
                                class: "fas fa-times expand_icon",
                                style: {"color":"white"},
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ChangingBit()))
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_Transition, {
                      name: "fade-slide",
                      onEnter: _ctx.onSectionLoaded
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.viewPostDetail && _ctx.viewPostDetail(...args)), ["stop"]))
                        }, [
                          (_ctx.isRepostView == undefined && !_ctx.isDetailView)
                            ? (_openBlock(), _createBlock(_component_PostInfoComponent, {
                                key: 0,
                                fromProfilePostCard: _ctx.fromProfilePostCard,
                                post: _ctx.post
                              }, null, 8, ["fromProfilePostCard", "post"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }, 8, ["onEnter"]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["post--content", _ctx.repostPost && !_ctx.isDetailView ? 'shared-post-body-inner' : ''])
                    }, [
                      _createVNode(_Transition, {
                        name: "fade-scale",
                        onAfterEnter: _ctx.onSectionRendered
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.viewPostDetail && _ctx.viewPostDetail(...args)), ["stop"]))
                          }, [
                            (!_ctx.isDetailView)
                              ? (_openBlock(), _createBlock(_component_PostProfile, {
                                  key: 0,
                                  user: _ctx.postUser,
                                  addPostModel: _ctx.post,
                                  postSubType: _ctx.post.postSubType,
                                  postType: _ctx.post.type,
                                  postPrivacy: _ctx.post.postPrivacy,
                                  postId: _ctx.post._id,
                                  onAvatarClick: _ctx.handleAvatarClick
                                }, null, 8, ["user", "addPostModel", "postSubType", "postType", "postPrivacy", "postId", "onAvatarClick"]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }, 8, ["onAfterEnter"]),
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_Transition, {
                          name: "fade-up",
                          appear: "",
                          onAfterEnter: _ctx.onTextRendered
                        }, {
                          default: _withCtx(() => [
                            (!_ctx.isDetailView)
                              ? (_openBlock(), _createBlock(_component_PostTextComponent, {
                                  key: 0,
                                  post: _ctx.post
                                }, null, 8, ["post"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["onAfterEnter"]),
                        _createElementVNode("span", {
                          onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.viewPostDetail && _ctx.viewPostDetail(...args)), ["stop"]))
                        }, [
                          (_ctx.isDetailView == undefined || _ctx.isDetailView == false)
                            ? (_openBlock(), _createBlock(_TransitionGroup, {
                                key: 0,
                                name: "content-stagger",
                                tag: "div",
                                onAfterEnter: _ctx.onSectionRendered
                              }, {
                                default: _withCtx(() => [
                                  (
                      _ctx.post.type == 'text' &&
                      _ctx.post.metaData &&
                      _ctx.post.metaData.length
                    )
                                    ? (_openBlock(), _createBlock(_component_PostMetaComponent, {
                                        meta: _ctx.post.metaData,
                                        key: 'meta-' + _ctx.post._id,
                                        onRendered: _ctx.onSectionRendered
                                      }, null, 8, ["meta", "onRendered"]))
                                    : _createCommentVNode("", true),
                                  (_ctx.post.type == 'charts' || _ctx.post.postSubType == 'charts')
                                    ? (_openBlock(), _createBlock(_component_FeedCandleChart, {
                                        key: 'chart-' + _ctx.post._id,
                                        post: _ctx.post
                                      }, null, 8, ["post"]))
                                    : _createCommentVNode("", true),
                                  (
                      _ctx.post.type == 'analysis' &&
                      _ctx.post.postSubType == 'watchlist'
                    )
                                    ? (_openBlock(), _createBlock(_component_WatchlistContainerComponent, {
                                        postModel: _ctx.post,
                                        className: "boardPost",
                                        key: 'watchlist-' + _ctx.post._id,
                                        onRendered: _ctx.onSectionRendered
                                      }, null, 8, ["postModel", "onRendered"]))
                                    : _createCommentVNode("", true),
                                  (
                      _ctx.post.type == 'analysis' &&
                      _ctx.post.postSubType == 'prediction' &&
                      _ctx.post.prediction &&
                      _ctx.post.prediction.length
                    )
                                    ? (_openBlock(), _createBlock(_component_PredictionContainerComponent, {
                                        postModel: _ctx.post,
                                        className: "boardPost",
                                        key: 'prediction-' + _ctx.post._id,
                                        onRendered: _ctx.onSectionRendered
                                      }, null, 8, ["postModel", "onRendered"]))
                                    : _createCommentVNode("", true),
                                  (
                      _ctx.post.type === 'profile' &&
                      _ctx.post.postSubType == 'highlights'
                    )
                                    ? (_openBlock(), _createBlock(_component_PostSectionSelectionPreviewComponent, {
                                        post: _ctx.post,
                                        key: 'highlights-' + _ctx.post._id,
                                        onRendered: _ctx.onSectionRendered
                                      }, null, 8, ["post", "onRendered"]))
                                    : _createCommentVNode("", true),
                                  (
                      _ctx.post.type === 'profile' && _ctx.post.postSubType == 'relations'
                    )
                                    ? (_openBlock(), _createBlock(_component_PostSectionSelectionRelationPreviewComponent, {
                                        post: _ctx.post,
                                        key: 'relations-' + _ctx.post._id,
                                        onRendered: _ctx.onSectionRendered
                                      }, null, 8, ["post", "onRendered"]))
                                    : _createCommentVNode("", true),
                                  (_ctx.post.type === 'text' && _ctx.post.postSubType === 'page')
                                    ? (_openBlock(), _createBlock(_component_PostPreviewComponent, {
                                        key: 6,
                                        "show-edit-dropdown": false,
                                        type: _ctx.postData?.type,
                                        content: _ctx.postData?.data || false,
                                        "current-page": _ctx.postData?.pageNumber,
                                        "total-pages": _ctx.post.pagePostData?.length || 1,
                                        "onUpdate:value": _ctx.setPage,
                                        value: _ctx.postData?.pageNumber || 1,
                                        onViewPostDetail: _ctx.viewPostDetail,
                                        onRendered: _ctx.onSectionRendered
                                      }, null, 8, ["type", "content", "current-page", "total-pages", "onUpdate:value", "value", "onViewPostDetail", "onRendered"]))
                                    : _createCommentVNode("", true),
                                  (
                      _ctx.post.type === 'analysis' && _ctx.post.postSubType == 'signal'
                    )
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                        (_ctx.post.signal)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                              _createVNode(_component_SignalCardItem, {
                                                addPostModelDv: _ctx.post.signal,
                                                onRendered: _ctx.onSectionRendered
                                              }, null, 8, ["addPostModelDv", "onRendered"])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  (
                      _ctx.post.type === 'portfolio' && _ctx.post.postSubType == 'trade'
                    )
                                    ? (_openBlock(), _createBlock(_component_PortfolioTradePostingCardComponent, {
                                        key: 8,
                                        stock: _ctx.post.stockTags[0],
                                        postUser: _ctx.postUser,
                                        trade: _ctx.post.trade,
                                        onRendered: _ctx.onSectionRendered
                                      }, null, 8, ["stock", "postUser", "trade", "onRendered"]))
                                    : _createCommentVNode("", true),
                                  (_ctx.post.media && _ctx.post.media.length)
                                    ? (_openBlock(), _createBlock(_component_PostMediaComponent, {
                                        media: _ctx.post.media,
                                        post: _ctx.post,
                                        showImageViewer: _ctx.showImageViewer,
                                        onShowPostDetail: _ctx.viewPostDetail,
                                        key: 'media-' + _ctx.post._id,
                                        onLoaded: _ctx.onMediaLoaded
                                      }, null, 8, ["media", "post", "showImageViewer", "onShowPostDetail", "onLoaded"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }, 8, ["onAfterEnter"]))
                            : _createCommentVNode("", true),
                          _createVNode(_TransitionGroup, {
                            name: "stagger-fade",
                            tag: "div",
                            onAfterEnter: _ctx.onRepostHeightStable
                          }, {
                            default: _withCtx(() => [
                              (_ctx.post.repostId && _ctx.repostPost && !_ctx.isRepostView)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (_ctx.isDetailView && !_ctx.post.media.length)
                                      ? (_openBlock(), _createBlock(_Teleport, {
                                          key: 0,
                                          to: `#teleport-post`,
                                          defer: ""
                                        }, [
                                          _createVNode(_component_PostCardComponent, {
                                            post: _ctx.repostPost,
                                            isRepostView: true,
                                            class: "shared-post",
                                            onHeightStabilized: _ctx.onRepostHeightStable
                                          }, null, 8, ["post", "onHeightStabilized"]),
                                          (_ctx.post.repostId && !_ctx.repostPost)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createVNode(_component_IconComponent, {
                                                  class: "iconinfoNoDataFoundDv",
                                                  icon: "Logo_grey.svg",
                                                  noRtlTransform: ""
                                                }),
                                                _cache[5] || (_cache[5] = _createElementVNode("p", { class: "paragaphDvinfoDv" }, " Orginal Post Has Been Deleted ", -1))
                                              ], 64))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : (!_ctx.isDetailView || _ctx.post.media.length)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createVNode(_component_PostCardComponent, {
                                              post: _ctx.repostPost,
                                              isRepostView: true,
                                              class: "shared-post",
                                              onHeightStabilized: _ctx.onRepostHeightStable
                                            }, null, 8, ["post", "onHeightStabilized"]),
                                            (_ctx.post.repostId && !_ctx.repostPost)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createVNode(_component_IconComponent, {
                                                    class: "iconinfoNoDataFoundDv",
                                                    icon: "Logo_grey.svg",
                                                    noRtlTransform: ""
                                                  }),
                                                  _cache[6] || (_cache[6] = _createElementVNode("p", { class: "paragaphDvinfoDv" }, " Orginal Post Has Been Deleted ", -1))
                                                ], 64))
                                              : _createCommentVNode("", true)
                                          ], 64))
                                        : _createCommentVNode("", true)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["onAfterEnter"])
                        ])
                      ], 512),
                      _createVNode(_Transition, {
                        name: "fade-up",
                        onAfterEnter: _ctx.onSectionRendered
                      }, {
                        default: _withCtx(() => [
                          (_ctx.isRepostView == undefined)
                            ? (_openBlock(), _createBlock(_component_PostFootComponent, {
                                key: 0,
                                isDetailView: _ctx.isDetailView,
                                sourceId: _ctx.post._id,
                                stockTags: _ctx.post.stockTags,
                                sourceType: "post",
                                post: _ctx.post,
                                onLikePost: _ctx.handleLikePost,
                                onUnlikePost: _ctx.handleUnlikePost,
                                fromOutside: _ctx.fromOutside,
                                postingData: _ctx.postingData
                              }, null, 8, ["isDetailView", "sourceId", "stockTags", "post", "onLikePost", "onUnlikePost", "fromOutside", "postingData"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["onAfterEnter"])
                    ], 2)
                  ], 6)
                ])
              ]),
              _: 1
            }, 8, ["setMinHeight", "style"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onEnter"])
  ], 64))
}